import React from "react";
import { Provider } from "react-redux";

import logo from "logo.png";
import EntryApp from "EntryApp";
import configureStore from "store/configureStore";
import "./App.scss";

class App extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      store: null
    };

    configureStore(store => {
      this.setState({
        isLoading: false,
        store
      });
    });
  }

  render() {
    const { isLoading, store } = this.state;

    if (isLoading) {
      return (
        <div className="App">
          <header className="App-header">
            <img src={logo} className="App-logo" alt="logo" />
            <p className="h1">Bienvenue sur le kiosque Star Alliance</p>
          </header>
        </div>
      );
    }
    return (
      <Provider store={store}>
        <EntryApp />
      </Provider>
    );
  }
}

export default App;
